/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Spin } from 'antd';
import { editEmpresa, fetchEmpresaById, limpiarEmpresa } from '../../../actions/empresa';
import { parserData } from '../../../utils/parsers/formData';
import FormCreateEditEmpresa from '../form';
import AccordionUsuarioProyecto from '../accordion-usuario-proyecto';
import { routeEmpresaInfo } from '../../../utils/routesBread';
import Bread from '../../../components/breadcrumb';
import { EMPRESA_PATH } from '../../../routes/path';

const InfoEmpresa = () => {
  const { empresa, isLoading } = useSelector((state) => state.empresaReducer);
  const [form, setForm] = useState({
    nombre: '',
    planta: '',
    descripcion: '',
    imagen: ''
  });
  const [disabled] = useState(true);
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (newForm) => {
    setForm(newForm);
  };

  const redirect = () => {
    navigate(EMPRESA_PATH);
  };

  const handleSubmitEdit = () => {
    dispatch(editEmpresa(id, parserData(form), redirect));
  };
  useEffect(() => {
    dispatch(fetchEmpresaById(id));
    return () => {
      dispatch(limpiarEmpresa());
    };
  }, []);

  useEffect(() => {
    setForm({
      nombre: empresa && empresa.nombre,
      planta: empresa && empresa.planta,
      descripcion: empresa && empresa.descripcion,
      imagen: empresa && empresa.imagen
    });
  }, [empresa]);

  return (
    <div>
      <div className="header-nav">
        <Bread routes={routeEmpresaInfo} />
      </div>
      <div className="info-container">
        {isLoading
          ? (
            <div className="container-spin">
              <Spin tip="Cargando..." />
            </div>
          )
          : (
            <>
              {empresa === undefined
                ? (
                  <p className="info-container__nothing">Los detalles de la empresa no se encontrarón</p>
                )
                : (
                  <>
                    <FormCreateEditEmpresa
                      data={form}
                      onSubmit={handleSubmitEdit}
                      onChange={handleChange}
                      disabled={disabled}
                    />
                    <AccordionUsuarioProyecto data={empresa} />
                  </>
                )}
            </>
          )}
      </div>
    </div>
  );
};

export default InfoEmpresa;
